// Номер ковра привязан к конкретному ноутбуку (браузеру), а не к пользователю или поединку —
// выбирается один раз перед турниром и хранится локально.
const MAT_NUMBER_KEY = 'judo_mat_number';

export const getMatNumber = (): string | null => {
  try {
    return localStorage.getItem(MAT_NUMBER_KEY);
  } catch {
    return null;
  }
};

export const setMatNumber = (value: string): void => {
  try {
    localStorage.setItem(MAT_NUMBER_KEY, value);
  } catch {
    // localStorage недоступен (приватный режим и т.п.) — просто не запоминаем
  }
};

export const clearMatNumber = (): void => {
  try {
    localStorage.removeItem(MAT_NUMBER_KEY);
  } catch {
    // ignore
  }
};
